import Konva from 'konva';
import type { PinDef } from '../../core/library/component-def.js';

/**
 * Dibuja una etiqueta pequeña asociada a un pin, colocada FUERA del
 * cuerpo del componente, junto al pin cerca del cuerpo.
 * Texto negro con un rectángulo blanco de resalte para que sea legible
 * sobre cualquier fondo (incluido el pin metálico).
 * Se envuelve en un grupo con contra-transformación: la etiqueta
 * mantiene orientación 0° world y nunca aparece invertida.
 *
 * `offsetMm`: distancia desde el anclaje del pin ALINEADA CON LA
 * DIRECCIÓN DEL PIN (positivo = hacia fuera del cuerpo).
 */
export function renderPinLabel(
  pin: PinDef,
  text: string,
  offsetMm: number,
  rotationDeg: number,
  flipped: boolean,
  fontSize: number,
): Konva.Group {
  const g = new Konva.Group({ listening: false });
  if (!text) return g;

  const dirRad = (pin.direction_deg * Math.PI) / 180;
  const dirX = Math.cos(dirRad);
  const dirY = Math.sin(dirRad);

  // Posición: desplaza el anclaje en dirección DEL pin (hacia fuera).
  const lx = pin.attachment.x + dirX * offsetMm;
  const ly = pin.attachment.y + dirY * offsetMm;

  const ps = flipped ? -1 : 1;
  const wrapper = new Konva.Group({
    x: lx,
    y: ly,
    rotation: ps * (0 - rotationDeg),
    scaleY: ps,
    listening: false,
  });
  const padX = fontSize * 0.3;
  const padY = fontSize * 0.15;
  const bgW = Math.max(text.length * fontSize * 0.65 + padX * 2, fontSize + padX * 2);
  const bgH = fontSize + padY * 2;
  wrapper.add(
    new Konva.Rect({
      x: -bgW / 2,
      y: -bgH / 2,
      width: bgW,
      height: bgH,
      cornerRadius: bgH * 0.3,
      fill: '#ffffff',
      opacity: 0.7,
      stroke: '#00000030',
      strokeWidth: 0.04,
      listening: false,
    }),
  );
  wrapper.add(
    new Konva.Text({
      x: -bgW / 2,
      y: -fontSize / 2,
      width: bgW,
      height: fontSize,
      text,
      fontSize,
      fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
      fontStyle: 'bold',
      fill: '#111111',
      align: 'center',
      verticalAlign: 'middle',
      listening: false,
    }),
  );
  g.add(wrapper);
  return g;
}
